import '../styles/index.scss'
import $ from 'jquery'
import App from './app'

if (!window.console) {
  window.console = {}
}

window.console.log =
  window.console.log ||
  function () {
    /* noop */
  }
window.console.warn =
  window.console.warn ||
  function () {
    /* noop */
  }
window.console.error =
  window.console.error ||
  function () {
    /* noop */
  }
window.console.info =
  window.console.info ||
  function () {
    /* noop */
  }

/* eslint-disable no-extend-native */
/**
 * Hack in support for Function.name for browsers that don't support it.
 * IE, I'm looking at you.
 **/
if (
  typeof Function.prototype.name === 'undefined' &&
  typeof Object.defineProperty !== 'undefined'
) {
  Object.defineProperty(Function.prototype, 'name', {
    get() {
      const funcNameRegex = /function\s([^(]{1,})\(/
      const results = funcNameRegex.exec(this.toString())
      return results && results.length > 1 ? results[1].trim() : ''
    },
    set() {
      // noop
    },
  })
}
/* eslint-enable no-extend-native */

$(() => {
  const app = new App([
    {
      name: 'AddProduct',
      ctx: 'body',
    },
    {
      name: 'SideNavigation',
      ctx: '.o-side-navigation',
    },
    {
      name: 'Header',
      ctx: '.o-header',
    },
    {
      name: 'TopNavigation',
      ctx: '.m-top-navigation.h-in-header',
    },
    {
      name: 'TopNavigationSidebar',
      ctx: '.m-top-navigation.h-in-sidebar',
    },
    {
      name: 'Cart',
      ctx: '.o-cart',
    },
    {
      name: 'CartIcon',
      ctx: '.a-cart-icon',
    },
    {
      name: 'Certificates',
      ctx: '.m-certificates',
    },
    {
      name: 'ProductsBoard',
      ctx: '.m-products-board',
    },
    {
      name: 'Tabs',
      ctx: '.m-tabs',
    },
    {
      name: 'Profile',
      ctx: '.o-profile',
    },
    {
      name: 'PrivacyPolicyBanner',
      ctx: '.a-privacy-policy-banner',
    },
  ])

  app.run()
})
